import ProductDetail from './ProductDetail';
import MockupMedicare from '../components/products/MockupMedicare';

const ProductMedicare = () => (
  <ProductDetail productId='medicare' Mockup={MockupMedicare} />
);

export default ProductMedicare;
